import {
    REPORT_SETTINGS_DEFAULT_REPORT_KEY,
    ReportSettingsReportKey,
} from "./report-settings-report-key";
import { AccountingReportType } from "./report-type";

export enum ReportSettingLogoOption {
    FIRM = "firm",
    ENTITY = "entity",
    BOTH = "both",
    NONE = "none",
}

export enum ReportSettingRowVisibility {
    ALL_ACCOUNTS = "all_accounts",
    WITH_ACTIVITY = "with_activity",
    NON_ZERO = "non_zero",
    GL_STANDARD = "gl_standard",
}

export const GL_ROW_VISIBILITY_VALUES: ReportSettingRowVisibility[] = [
    ReportSettingRowVisibility.GL_STANDARD,
    ReportSettingRowVisibility.ALL_ACCOUNTS,
];

export const STATEMENT_ROW_VISIBILITY_VALUES: ReportSettingRowVisibility[] = [
    ReportSettingRowVisibility.ALL_ACCOUNTS,
    ReportSettingRowVisibility.WITH_ACTIVITY,
    ReportSettingRowVisibility.NON_ZERO,
];

// A saved layout row carries whatever value was persisted for its report type,
// and nothing validates that value against the type on write, so every consumer
// re-checks it before it reaches a data service.
export function pickAllowedRowVisibility(
    reportType: AccountingReportType,
    rowVisibility?: ReportSettingRowVisibility,
): ReportSettingRowVisibility | undefined {
    const allowed =
        reportType === AccountingReportType.GENERAL_LEDGER
            ? GL_ROW_VISIBILITY_VALUES
            : STATEMENT_ROW_VISIBILITY_VALUES;
    return rowVisibility && allowed.includes(rowVisibility)
        ? rowVisibility
        : undefined;
}

export const REPORT_SETTINGS_WATERMARK_MAX_LENGTH = 50;

export function getReportSettingsRowVisibilityOptions(
    reportKey: ReportSettingsReportKey,
): ReportSettingRowVisibility[] | null {
    switch (reportKey) {
        case AccountingReportType.GENERAL_LEDGER:
            return GL_ROW_VISIBILITY_VALUES;
        case REPORT_SETTINGS_DEFAULT_REPORT_KEY:
        case AccountingReportType.PROFIT_LOSS:
        case AccountingReportType.BALANCE_SHEET:
        case AccountingReportType.TRIAL_BALANCE:
        case AccountingReportType.EXPENSE_BY_VENDOR:
        case AccountingReportType.CASH_FLOW_STATEMENT:
            return STATEMENT_ROW_VISIBILITY_VALUES;
        case AccountingReportType.AR_AGING_SUMMARY:
        case AccountingReportType.AR_AGING_DETAIL:
        case AccountingReportType.SCHEDULES:
            return null;
    }
}
